import { DataNode } from 'components/elements/Form/select/NestedAntdMultiSelect';
import { SeamVisionlineDoorsProps } from 'services/hooks/seam-assa-visionline-service';
import { sortDataNodesByTitle } from './helpers';

export const FormatVisionlineDoorsTreeData = (
  data: SeamVisionlineDoorsProps[] | null
): DataNode[] => {
  if (!data) {
    return [];
  }

  const groupedByProfile = data.reduce((acc: { [key: string]: DataNode }, door) => {
    const { profileType, acsEntranceId, displayName } = door;
    if (!acc[profileType]) {
      acc[profileType] = {
        title: profileType,
        value: profileType,
        key: profileType,
        children: []
      };
    }
    acc[profileType].children?.push({
      title: displayName,
      value: acsEntranceId,
      key: acsEntranceId
    });
    return acc;
  }, {} as { [key: string]: DataNode }); // Explicitly state the type of the accumulator

  // Sort doors
  Object.values(groupedByProfile).forEach((group) => {
    group.children = sortDataNodesByTitle(group.children);
  });

  return Object.values(groupedByProfile);
};

export default FormatVisionlineDoorsTreeData;
